<template>
  <iRow
    class="header-menu"
    type="flex"
    align="middle">
    <div class="layout-logo">
      <img
        class="logo-img"
        src="@/assets/images/logos/formaat-white.svg">
    </div>
    <iButton
      :class="{ 'is-active': sidebar.collapsed }"
      type="text"
      class="hamburger-btn"
      @click="toggleSidebar"
    >
      <iIcon
        type="navicon"
        color="white"
        size="32"/>
    </iButton>
    <iBreadcrumb class="flex-grow"/>
    <ProfileMenu :profile="extendedProfile"/>
  </iRow>
</template>

<script>
import { mapState, mapActions } from 'vuex';
import Breadcrumb from './components/Breadcrumb.vue';
import ProfileMenu from './components/ProfileMenu.vue';

export default {
  components: { Breadcrumb, ProfileMenu },
  data() {
    return {
    };
  },
  computed: {
    ...mapState('Settings', ['sidebar']),
    ...mapState('Profile', ['profile']),
    extendedProfile() {
      return {
        ...this.profile,
        fullName: `${this.profile.firstName || ''} ${this.profile.lastName || ''}`,
        employeeNumber: this.profile.email,
        avatarUrl: 'https://www.gravatar.com/avatar',
      };
    },
  },
  methods: {
    ...mapActions('Settings', ['toggleSidebar']),
  },
};
</script>
<style scoped>

.header-menu {
  height: 100%;
  display: flex;
  flex-wrap: nowrap;
}

.logo-img {
  height: 100%;
  width: 100%;
}

.layout-logo {
  width: 140px;
  height: 30px;
  /* background: #5b6270; */
  border-radius: 3px;
  margin: 0 30px 0 18px;
}

.layout-nav {
  width: 420px;
  margin: 0 auto;
  margin-right: 20px;
}

.hamburger-btn {
  transform: rotateZ(0deg);
  transform-origin: 50% 50%;
  transition: .38s;
}
.hamburger-btn.is-active {
  transform: rotateZ(90deg);
}
</style>
